<dialog
  #dialog
  qai-dialog
  [heading]="'call.LEAVE_STEP_TITLE' | transloco"
  [description]="''"
  [showClose]="false"
  (closeButtonClicked)="onResume()"
>
  <div class="call-leave-early">
    <div class="message">
      {{ description }}
    </div>

    <div class="actions">
      <button
        qai-button
        type="button"
        [size]="'large'"
        [kind]="'secondary'"
        (click)="endCall()"
      >
        {{ "call.EXIT" | transloco }}
      </button>

      <button
        qai-button
        type="button"
        [size]="'large'"
        [kind]="'primary'"
        (click)="onResume()"
      >
        {{ "call.RESUME" | transloco }}
      </button>
    </div>
  </div>
</dialog>
